module.exports = __webpack_public_path__ + "img/580.3257f259.jpg";